<div class="popover-wrapper">
    <div class="popover-header">{{title}}</div>
    <div class="layout-container">
        <kve-banner-cell-layout></kve-banner-cell-layout>
    </div>
</div>
